export const GLIDE_CLASSES = {
	direction: {
		ltr: "glide-ltr",
		rtl: "glide-rtl",
	},
	slider: "glide-slider",
	carousel: "glide-carousel",
	swipeable: "glide-swipeable",
	dragging: "glide-dragging",
	cloneSlide: "glide-slide-clone",
	activeNav: "glide-bullet-active",
	activeSlide: "glide-slide-active",
	disabledArrow: "glide-arrow-disabled",
};
